import type { FC } from "react";

interface Column {
  percentage: number;
  width?: string;
}

export interface InsightsTableRowData {
  value: string;
  columns: Column[];
}

interface InsightsTableProps {
  rowData: InsightsTableRowData[];
  headerColumns?: string[];
}

const getBackgroundColor = (percentage: number) => {
  if (percentage >= 80) return "bg-blue-700 text-white";
  if (percentage >= 60) return "bg-blue-500 text-white";
  if (percentage >= 40) return "bg-blue-300 text-foreground";
  if (percentage >= 20) return "bg-blue-100 text-foreground";
  if (percentage > 0) return "bg-blue-50 text-foreground";
  return "bg-white text-foreground";
};

export const InsightsTable: FC<InsightsTableProps> = ({
  rowData,
  headerColumns,
}) => {
  return (
    <div className="overflow-hidden shadow-sm ring-1 ring-black/5">
      <table className="min-w-full divide-y divide-border-light">
        {headerColumns && headerColumns.length > 0 && (
          <thead className="bg-gray-50">
            <tr>
              <th
                className="py-1 pr-2 pl-3 text-left text-sm font-medium text-foreground"
                scope="col"
              ></th>
              {headerColumns.map((name, index) => (
                <th
                  key={index}
                  className="w-[14%] px-2 py-1 text-center text-sm font-medium text-foreground"
                  scope="col"
                >
                  {name}
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody className="divide-y divide-border-light bg-white">
          {rowData.map((row, rowIndex) => (
            <tr key={rowIndex} className="divide-x divide-border-light">
              <td className="border-r border-border-light py-2 pr-2 pl-3 text-left text-sm font-medium text-foreground">
                {row.value}
              </td>
              {row.columns.map((col, colIndex) => (
                <td
                  key={colIndex}
                  className={`px-3 py-3 text-center text-sm font-medium text-foreground ${getBackgroundColor(
                    col.percentage,
                  )}`}
                  style={{ width: col.width }}
                >
                  {`${col.percentage.toFixed(0)}%`}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
